<div class="sign-in-page">
    <div fxLayout="column" fxLayoutAlign="end center" class="powered-logo">
        <img src="assets/new-image/logos/PoweredBy.svg" />
    </div>

    <div class="sign-up-form-wrapper" fxLayout="column" fxLayoutAlign="end end">
        <div
            class="sign-up-form"
            fxLayout="column"
            fxLayoutAlign="start center"
            [@animate]="{
                value: '*',
                params: { duration: '300ms', x: '-50px' }
            }"
        >
            <div class="logo">
                <img src="../../../../../assets/new-image/logos/Group.svg" />
            </div>

            <h1 class="sign-up-title">Sign Up</h1>

            <form name="signUpForm" class="form-grid">
                <div
                    class="user-details"
                    fxLayout="column"
                    fxLayoutAlign="start center"
                >
                    <h4>Account Information</h4>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>First Name</mat-label>
                        </div>

                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="firstName"
                                type="text"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Last Name</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="lastName"
                                type="text"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Email</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="email"
                                type="email"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Password</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="password"
                                type="password"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Confirm Password</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="confirmPassword"
                                type="password"
                                required
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div
                    class-="company-fields"
                    fxLayout="column"
                    fxLayoutAlign="start center"
                >
                    <h4>Company Information</h4>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Company Name</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="phoneNumber"
                                type="text"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div
                        class="form-field-container"
                        fxLayout="column"
                        fxLayoutAlign="start center"
                    >
                        <div class="form-field-title">
                            <mat-label>Domain</mat-label>
                        </div>
                        <mat-form-field appearance="fill">
                            <input
                                matInput
                                name="address"
                                type="text"
                                required
                            />
                        </mat-form-field>
                    </div>
                </div>
            </form>

            <!-- <button mat-raised-button class="submit-button">
                <span class="button-logo material-symbols-outlined">
                    login
                </span>
                Sign Up
            </button> -->
        </div>
    </div>
</div>
